import { useCallback } from 'react'
import type {
  DateFilterValue,
  FilterValue,
  UseDateRangeFilterReturn,
} from '../types/data-table.types'

export function useDateRangeFilter(
  value: DateFilterValue | undefined,
  onChange: (value: FilterValue) => void,
): UseDateRangeFilterReturn {
  const handleFromChange = useCallback(
    (date: Date | undefined) => {
      const newValue = {
        ...(value || {}),
        from: date?.toISOString(),
      }

      if (!newValue.from && !newValue.to) {
        onChange(undefined)
      } else {
        onChange(newValue)
      }
    },
    [value, onChange],
  )

  const handleToChange = useCallback(
    (date: Date | undefined) => {
      const newValue = {
        ...(value || {}),
        to: date?.toISOString(),
      }

      if (!newValue.from && !newValue.to) {
        onChange(undefined)
      } else {
        onChange(newValue)
      }
    },
    [value, onChange],
  )

  const fromDate = value?.from ? new Date(value.from) : undefined
  const toDate = value?.to ? new Date(value.to) : undefined

  const hasValidationError = Boolean(fromDate && toDate && fromDate > toDate)

  return {
    handleFromChange,
    handleToChange,
    fromDate,
    toDate,
    hasValidationError,
  }
}
